/**
 * The reviewer's reading of a 422 from admin's JSON routes (PRD-628): one reason string.
 *
 * The route answers two shapes: the store's refusals are a string `detail`, a malformed body is
 * FastAPI's list of `{loc, msg}` entries. Both read to the words the reviewer is shown.
 */
import type { components } from './types/api';

type ValidationError = components['schemas']['HTTPValidationError'];

/** The words a failed call carries (the server's own, as the typed client threw them), or a plain line when it carries none. */
export function messageOf(error: unknown): string {
  return error instanceof Error ? error.message : 'the server did not answer';
}

/** The words of one 422 body: the string detail as it is, the list joined by its fields. */
export function refusalReason(body: { detail?: ValidationError['detail'] | string }): string {
  const detail = body.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (!detail || detail.length === 0) {
    return 'refused';
  }
  return detail.map((entry) => `${entry.loc.slice(1).join('.')}: ${entry.msg}`).join('; ');
}
